const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Content Integrations Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('ContentIntegrations', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/v3/content-integrations/:subresource/:name', null, {
    exists: {params: {subresource: 'existing'}, method: 'GET', isArray: false},
    existing: {params: {subresource: 'existing'}, method: 'GET', isArray: false},
    getLil: {params: {subresource: 'lil-access'}, method: 'GET', isArray: false},
    lilClassifications: {params: {subresource: 'lil-classifications'}, method: 'GET', isArray: false},
    limitedFind: {params: {subresource: ''}, method: 'GET', isArray: false},
    udemyCourse: {params: {subresource: 'udemy-course'}, method: 'GET', isArray: false},
    lilCourse: {params: {subresource: 'lil-course'}, method: 'GET', isArray: false},
    token: {params: {subresource: 'token'}, method: 'GET', isArray: false},
    searchContent: {params: {subresource: 'search-content'}, method: 'POST', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false}
  });
}]);